import { Box, Checkbox, TextField, Typography } from '@mui/material';
import { EValueType, IField } from '../../../models/form/form';
import { HTMLInputTypeAttribute } from 'react';

const textFieldTypes: Map<EValueType, HTMLInputTypeAttribute> = new Map([
    [EValueType.Date, 'date'],
    [EValueType.Number, 'number'],
    [EValueType.SingleLineText, 'text'],
    [EValueType.MultiLineText, 'text'],
    [EValueType.Boolean, 'checkbox'],
]);

interface IFieldProps {
    field: IField;
}

const InputField = ({ field }: IFieldProps) => {
    return (
        <Box sx={{ width: "100%" }}>
            <Box marginBottom={1} display={field.valueType === EValueType.Boolean ? "inline" : "block"}>
                <Typography display="inline">{field.text.trim()}</Typography>
                {field.required && <Typography display="inline" color="error"> *</Typography>}
            </Box>
            {field.valueType === EValueType.Boolean ? <Checkbox disabled></Checkbox>
                : <TextField
                    type={textFieldTypes.get(field.valueType)}
                    required={field.required}
                    value={""}
                    fullWidth
                    multiline={field.valueType === EValueType.MultiLineText}
                    rows={4}
                    disabled
                ></TextField>
            }

        </Box>
    );
};

export default InputField;
